/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import AsyncStorage from '@react-native-async-storage/async-storage';
import { Crashlytics } from '../firebase/config';

const SHOULD_SHOW_TUTORIAL = 'SHOULD_SHOW_TUTORIAL';


//Checks to see if tutorial token exists
const getShouldShowTutorial = async () => {
//console.log("Running Tutorial Check...");
try {
const result = await AsyncStorage.getItem(SHOULD_SHOW_TUTORIAL)
//console.log("Tutorial Check Result: ", result !==null ? false : true);
return result === null
} catch (err) {
console.error("Error getting tutorial validation");
Crashlytics.recordError(err);
}
}


//Sets tutorial token -- dismissing tutorial moving forward.
const setShouldShowTutorial = async (value) => {
try {
await AsyncStorage.setItem(SHOULD_SHOW_TUTORIAL, value)
//await AsyncStorage.removeItem(SHOULD_SHOW_TUTORIAL);
} catch (err) {
console.error("Error setting tutorial validation", err);
Crashlytics.recordError(err);
}
console.log(SHOULD_SHOW_TUTORIAL, value);
}

//Clears tutorial token
const clearTutorial = async () => {
try {
await AsyncStorage.removeItem(SHOULD_SHOW_TUTORIAL);
} catch (err) {
console.error("Error setting tutorial validation", err);
Crashlytics.recordError(err);
}
};


const TutorialDeviceStorage = {
getShouldShowTutorial,
setShouldShowTutorial,
clearTutorial
}
export default TutorialDeviceStorage